import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_12 = { class: "control-label col-sm-6" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_16 = { class: "control-label col-sm-6" }
const _hoisted_17 = { class: "col-sm" }
const _hoisted_18 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_19 = { class: "control-label col-sm-6" }
const _hoisted_20 = { class: "col-sm" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_23 = { class: "control-label col-sm-6" }
const _hoisted_24 = { class: "col-sm" }
const _hoisted_25 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_26 = { class: "control-label col-sm-6" }
const _hoisted_27 = { class: "col-sm" }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_30 = { class: "control-label col-sm-6" }
const _hoisted_31 = { class: "col-sm" }
const _hoisted_32 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_33 = { class: "control-label col-sm-6" }
const _hoisted_34 = { class: "col-sm" }

import { watch , ref, inject} from 'vue'
import { usePreventivo } from '../../composable/usePreventivo'
import FormFamigliaAttiMortisCausaHelper from "../../pages/preventivi/json/attimortiscausa/helper.json";
import DettaglioPreventivoHelper from "../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormFamigliaAttiMortisCausa',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo', 'infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categorieValidazione
} = usePreventivo()
const props = __props
const emits = __emit
const { regimeFiscale } = inject('regimeFiscale')
let validazione;
const validazioneEquoCompenso = ref();
switch (props.formName) {
  case 'accettazioneEredita':
    validazione = categorieValidazione.categoriaAttiMortisCausa['sottocategoriaAttiMortisCausa']['accettazioneEredita']
    validazioneEquoCompenso.value = categorieValidazione.categoriaAttiMortisCausa['sottocategoriaAttiMortisCausa']['accettazioneEredita']
    break
  case 'rinunciaEredita':
    validazione = categorieValidazione.categoriaAttiMortisCausa['sottocategoriaAttiMortisCausa']['rinunciaEredita']
    validazioneEquoCompenso.value = categorieValidazione.categoriaAttiMortisCausa['sottocategoriaAttiMortisCausa']['rinunciaEredita']
    break
  case 'pubblicazioneTestamentoOlografo':
    validazione = categorieValidazione.categoriaAttiMortisCausa['sottocategoriaAttiMortisCausa']['pubblicazioneTestamentoOlografo']
    validazioneEquoCompenso.value = categorieValidazione.categoriaAttiMortisCausa['sottocategoriaAttiMortisCausa']['pubblicazioneTestamentoOlografo']
    break
  case 'passaggioAgliAttiTraViviDiTestamentoPubblico':
    validazione = categorieValidazione.categoriaAttiMortisCausa['sottocategoriaAttiMortisCausa']['passaggioAgliAttiTraViviDiTestamentoPubblico']
    validazioneEquoCompenso.value = categorieValidazione.categoriaAttiMortisCausa['sottocategoriaAttiMortisCausa']['passaggioAgliAttiTraViviDiTestamentoPubblico']
    break
}
const testoInfoCompilazione = ref([]);
testoInfoCompilazione.value =  FormFamigliaAttiMortisCausaHelper.sottocategoriaAttiMortisCausa[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if (validazione) {
  validazione.tipo_preventivo.value = 'atti_mortis_causa/atti_mortis_causa/' + props.tipoPreventivo.data.url
}
watch(validazione, () => {
  emits('changeDatiPreventivo')
}, { deep: true })
let indexHelperClosing = {
  calcolo:  FormFamigliaAttiMortisCausaHelper.sottocategoriaAttiMortisCausa[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}
function controlloNumeroConservatorie(event){
  let numero = event.target.value;
  validazione.imposta_ipotecaria_per_ciascuna_conservatoria.required = numero > 1;
}
function tipoAccettazione(event){
  let accettazione = event.target.value;
  if(accettazione == 'accettazione_espressa'){
    validazione.numero_marche_da_bollo.value = '0';
    validazione.numero_conservatorie.value = '0';
  } else if(accettazione == 'accettazione_con_beneficio_di_inventario') {
    validazione.numero_marche_da_bollo.value = '2';
    validazione.numero_conservatorie.value = '1';
  }
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'accettazioneEredita')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).tipo_accettazione.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_accettazione.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_select, {
                name: "tipo_accettazione",
                options: [{name: 'Accettazione espressa', value: 'accettazione_espressa'},{name: 'Accettazione con beneficio di inventario', value: 'accettazione_con_beneficio_di_inventario'}],
                isSelected: _unref(validazione).tipo_accettazione.value !== '',
                onChange: _cache[0] || (_cache[0] = $event => (tipoAccettazione($event))),
                state: __props.readonly === true ?'disable':'',
                validateTo: _unref(validazione).tipo_accettazione,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).tipo_accettazione) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(validazione).numero_marche_da_bollo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_marche_da_bollo.ref]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_input_text, {
                id: "numero_marche_da_bollo",
                name: "numero_marche_da_bollo",
                class: "placeholder-right crm:text-right",
                placeholder: "Indicare numero marche da bollo",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).numero_marche_da_bollo,
                "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).numero_marche_da_bollo) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
              _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_base_input_text, {
                id: "numero_conservatorie",
                name: "numero_conservatorie",
                class: "placeholder-right crm:text-right",
                placeholder: "Indicare numero conservatorie",
                onChange: _cache[3] || (_cache[3] = $event => (controlloNumeroConservatorie($event))),
                disabled: __props.readonly,
                "validate-to": _unref(validazione).numero_conservatorie,
                "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).numero_conservatorie) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          (_unref(validazione).numero_conservatorie.value > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.imposta_ipotecaria_per_ciascuna_conservatoria.ref]
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_base_select, {
                    name: "imposta_ipotecaria_per_ciascuna_conservatoria",
                    options: [{name: 'Si', value: 'si'},{name: 'No', value: 'no'}],
                    isSelected: _unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria.value !== '',
                    state: __props.readonly === true ?'disable':'',
                    validateTo: _unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria,
                    "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).imposta_ipotecaria_per_ciascuna_conservatoria) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly,
            "filter-options-d": true
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'rinunciaEredita')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_16, [
                _createTextVNode(_toDisplayString(_unref(validazione).numero_marche_da_bollo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_marche_da_bollo.ref]
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_base_input_text, {
                  id: "numero_marche_da_bollo",
                  name: "numero_marche_da_bollo",
                  class: "placeholder-right crm:text-right",
                  placeholder: "Indicare numero marche da bollo",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).numero_marche_da_bollo,
                  "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).numero_marche_da_bollo) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_19, [
                _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_base_input_text, {
                  id: "numero_conservatorie",
                  name: "numero_conservatorie",
                  class: "placeholder-right crm:text-right",
                  placeholder: "Indicare numero conservatorie",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).numero_conservatorie,
                  "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).numero_conservatorie) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "",
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly,
              "filter-options-d": true
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : (__props.formName === 'pubblicazioneTestamentoOlografo')
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_unref(validazione).numero_marche_da_bollo.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_marche_da_bollo.ref]
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_base_input_text, {
                    id: "numero_marche_da_bollo",
                    name: "numero_marche_da_bollo",
                    class: "placeholder-right crm:text-right",
                    placeholder: "Indicare numero marche da bollo",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).numero_marche_da_bollo,
                    "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).numero_marche_da_bollo) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_26, [
                  _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_base_input_text, {
                    id: "numero_conservatorie",
                    name: "numero_conservatorie",
                    class: "placeholder-right crm:text-right",
                    placeholder: "Indicare numero conservatorie",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).numero_conservatorie,
                    "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).numero_conservatorie) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createVNode(RegimeFiscale, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(AliquoteContributiRepertoriali, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(CalcoloEquoCompenso, {
                "input-riferimento-calcolo": "",
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly,
                "filter-options-d": true
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
            ]))
          : (__props.formName === 'passaggioAgliAttiTraViviDiTestamentoPubblico')
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_30, [
                    _createTextVNode(_toDisplayString(_unref(validazione).numero_marche_da_bollo.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_marche_da_bollo.ref]
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_base_input_text, {
                      id: "numero_marche_da_bollo",
                      name: "numero_marche_da_bollo",
                      class: "placeholder-right crm:text-right",
                      placeholder: "Indicare numero marche da bollo",
                      disabled: __props.readonly,
                      "validate-to": _unref(validazione).numero_marche_da_bollo,
                      "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).numero_marche_da_bollo) = $event))
                    }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_33, [
                    _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_base_input_text, {
                      id: "numero_conservatorie",
                      name: "numero_conservatorie",
                      class: "placeholder-right crm:text-right",
                      placeholder: "Indicare numero conservatorie",
                      disabled: __props.readonly,
                      "validate-to": _unref(validazione).numero_conservatorie,
                      "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).numero_conservatorie) = $event))
                    }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                  ])
                ]),
                _createVNode(RegimeFiscale, {
                  validazione: _unref(validazione),
                  helper: _unref(indexHelperClosing),
                  readonly: __props.readonly
                }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
                _createVNode(AliquoteContributiRepertoriali, {
                  validazione: _unref(validazione),
                  helper: _unref(indexHelperClosing),
                  readonly: __props.readonly
                }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
                _createVNode(CalcoloEquoCompenso, {
                  "input-riferimento-calcolo": "",
                  validazione: validazioneEquoCompenso.value,
                  helper: _unref(indexHelperClosing),
                  readonly: __props.readonly,
                  "filter-options-d": true
                }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
              ]))
            : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}